export enum DialogResult {
    None = 0,
    Ok = 1,
    Cancel = 2
}